// A storefront's palette, remembered per slug.
//
// The loading screen renders precisely when the store's skin is still null —
// that is what it is waiting for — so the loader has no colours of its own to
// work with and used to show a white page with a blue bar, even in front of a
// dark store. Caching the template's tokens on a successful load lets every
// LATER visit paint the loader in the store's own colours. A first-ever visit
// still falls back to the neutral treatment; we genuinely do not know the
// palette yet, and guessing it would flash the wrong brand.

const key = (slug) => `mktskin_${slug}`;

export const cacheStoreSkin = (slug, t) => {
  if (!slug || !t) return;
  try {
    localStorage.setItem(key(slug), JSON.stringify({
      bg: t.bg ?? '', ink: t.ink ?? '', accent: t.accent ?? '', dark: t.dark === true,
    }));
  } catch { /* private mode — the loader just stays neutral */ }
};

export const readStoreSkin = (slug) => {
  if (!slug) return null;
  try {
    const raw = localStorage.getItem(key(slug));
    if (!raw) return null;
    const t = JSON.parse(raw);
    return t && typeof t === 'object' ? t : null;
  } catch { return null; }
};
